import { Roles } from 'src/constants/RoleConstants'

export const isUserEmployee = (state) => !!state.auth.employee
export const isUserDeveloper = (state) =>
  state.auth.roles?.some((role) => +(role?.id ?? role) === Roles.DEVELOPER) || false
